export default __webpack_public_path__ + "static/media/thumb_2.b4dca572.webp";